module.exports = __webpack_public_path__ + "img/quotes.bbfc1bbf.svg";